import { render, staticRenderFns } from "./WeeklyCalendarProject.vue?vue&type=template&id=01c65c04&"
import script from "./WeeklyCalendarProject.vue?vue&type=script&lang=js&"
export * from "./WeeklyCalendarProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports